import ListSearchBar from "../ListSearchBar";
import React, { useState, useEffect } from "react";
import { Dropdown, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { PropagateLoader } from "react-spinners";
import ReactPaginate from "react-paginate";
import {
  DownloadModal,
  generateExcelFile,
  generatePDFFile,
  generateProgramExcel,
  handleDownloadConfirm,
} from "../../utilities/functions";
import { toast } from "react-toastify";
import ImportExcelButton from "./ImportExcelButton";
import ModalItinerary from "./ModalItinerary";

import { LocalizationProvider, DateTimePicker, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/fr"; // Support du français
import ModalDeletePrograms from "./DeletePrograms";


interface ProgramInterface {
  id_program: number;
  id_site?: number;
  program_date?: string;
  site?: string;
  name?: string;
  client_name?: string;
  departure?: string;
  destination?: string;
  type?: string;
  observation?: string;
  status: string;
  nom_conducteur?: string;
  prenom_conducteur?: string;
  immatriculation_vehicule?: string;
  PSN?: string;
  num_porte_vehicule?: string;
}

interface ProgramTableProps {
  loading: boolean;
  programs: ProgramInterface[];
  id_site?: number | null;
  selectedColumns: Record<string, boolean>;
  copiedId?: string | null;
  copyToClipboard?: (text: string, id: string) => void;
  translate: (key: string) => string;

  // Sorting
  sortColumn: string;
  sortOrder: "ASC" | "DESC";
  handleSortingColumn: (column: string) => void;

  // Modals
  handleShowNewDeadlineModal: () => void;
  handleEditProgramModal: (program: any) => void;
  handleShowShowProgramModal: (id: number) => void;
  handleDeleteProgramModal: (id: number) => void;

  getStatusIcon: (status: string) => React.ReactNode;

  // Pagination
  limit: number;
  total: number;
  pageCount: number;

  currentPage: number;
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handlePageClick: (data: any) => void;

  // Columns
  columnsMap: Record<string, string>;
  handleColumnChange: (col: string) => void;
  initialColumns: Record<string, boolean>;

  // Search
  menuItems: string[];
  handleTypeSearch: (val: string) => void;
  search: string;
  handleAdvancedSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;

  fetchPrograms?: () => void;

  filterDate: string | null;
  onFilterDateChange: (val: string | null) => void;
}

const ProgramTable: React.FC<ProgramTableProps> = ({
  loading,
  programs,
  id_site,
  selectedColumns,
  copiedId,
  copyToClipboard,
  translate,
  sortColumn,
  sortOrder,
  handleSortingColumn,
  handleShowNewDeadlineModal,
  handleEditProgramModal,
  handleShowShowProgramModal,
  handleDeleteProgramModal,
  getStatusIcon,
  limit,
  total,
  pageCount,
  currentPage,
  handleSelectChange,
  handlePageClick,
  columnsMap,
  handleColumnChange,
  initialColumns,
  handleTypeSearch,
  handleAdvancedSearch,
  search,
  fetchPrograms,
  onFilterDateChange,
  filterDate
}) => {
  const id_user = localStorage.getItem("userid");

  const [localTypeSearch, setLocalTypeSearch] = useState(
    id_user === "1" ? translate("ID Program") : translate("Client")
  );

const getColumnNumber = (columnName: string) => {
  return filteredMenuItems.findIndex(item => item.value === columnName);
};


  const filteredMenuItems = [
    ...(id_user === "1" ? [{ label: translate("ID Program"), value: "id_program" }] : []),
    //  { label: translate("Program Date"), value: "program_date" },
    { label: "Client", value: "client_name" },
    { label: "Departure", value: "departure" },
    { label: "Destination", value: "destination" },
    { label: "Type", value: "type" },
    { label: "Driver", value: "nom_conducteur" },
    { label: "Vehicle", value: "immatriculation_vehicule" },
    { label: "Observation", value: "observation" },
    { label: "Status", value: "status" },
  ];

  const handleLocalTypeSelection = (item: { label: string; value: string }) => {
    setLocalTypeSearch(item.label); // affichage

    const numero = getColumnNumber(item.value)+2; 
    handleTypeSearch(numero.toString());

  };


  const [showDeleteMultipleModal, setShowDeleteMultipleModal] = useState(false);

  // Ouvrir le modal pour la suppression multiple
  const handleDeleteSelectedPrograms = () => {
    if (selectedProgramsFromTable.length === 0) {
      toast.warn("Veuillez sélectionner au moins un programme à supprimer.", {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }
    setShowDeleteMultipleModal(true);
  };



  // --- Selection multiple ---
  const [selectedProgramsFromTable, setSelectedProgramsFromTable] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleProgramsSelect = (programId: string) => {
    setSelectedProgramsFromTable((prevSelected) => {
      const updated = prevSelected.includes(programId)
        ? prevSelected.filter((id) => id !== programId)
        : [...prevSelected, programId];

      // Met à jour le selectAll si toutes les lignes sont sélectionnées
      setSelectAll(updated.length === programs.length);
      return updated;
    });
  };

  // Select / deselect all
  const handleSelectAllPrograms = (checked: boolean) => {
    setSelectAll(checked);
    if (checked) {
      const allIds = programs.map((p) => String(p.id_program));
      setSelectedProgramsFromTable(allIds);
    } else {
      setSelectedProgramsFromTable([]);
    }
  };


  const formatProgramDate = (value?: string): string => {
    if (!value) return "";

    // Si la date est déjà au format 15/07/2025, on ne touche pas
    const alreadyFr = /^\d{2}\/\d{2}\/\d{4}$/.test(value);
    if (alreadyFr) return value;

    // Sinon on essaie de parser (ex : "2025-07-15T00:00:00.000Z" ou "2025-07-15")
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      // Si on n'arrive pas à parser, on renvoie tel quel pour ne pas perdre l'info
      return value;
    }

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };




  const downloadProgramExcel = async () => {
    const selectedPrograms: ProgramInterface[] = programs.filter((p) =>
      selectedProgramsFromTable.includes(String(p.id_program))
    );

    if (!selectedPrograms.length) {
      toast.warn("Veuillez sélectionner au moins un programme.", {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    // 👉 On formate la date pour chaque programme en DD/MM/YYYY
    const selectedProgramsFormatted: ProgramInterface[] = selectedPrograms.map((p) => ({
      ...p,
      program_date: formatProgramDate(p.program_date),
    }));

    await generateProgramExcel("PROGRAMME", selectedProgramsFormatted);
  };


  // Export PDF
  const downloadProgramPDF = () => {
    // if (!selectedPrograms || selectedPrograms.length === 0) {
    //   toast.warn("Please select at least one program", {
    //     position: "bottom-right",
    //     autoClose: 3000,
    //   });
    //   return;
    // }
    const headers = [
      translate("Program Date"),
      translate("Client"),
      translate("Departure"),
      translate("Destination"),
      translate("Type"),
      translate("Driver"),
      translate("Vehicle"),
      translate("Observation"),
      translate("Status"),
    ];
    const selectedData = programs
      .filter((p) => selectedProgramsFromTable.includes(String(p.id_program)))
      .map((program) => [
        program.program_date || "",
        program.client_name || "",
        program.departure || "",
        program.destination || "",
        program.type || "",
        `${program.nom_conducteur || ""} ${program.prenom_conducteur || ""}`,
        program.num_porte_vehicule || "",
        program.observation || "",
        program.status || "",
      ]);

    generatePDFFile(translate("Program"), headers, selectedData);
  };

  const [showDownloadModalProgram, setShowDownloadModalProgram] =
    useState(false);

  // Confirmation téléchargement
  const onDownloadConfirmProgram = (format: string) => {
    if (selectedProgramsFromTable.length > 0) {
      handleDownloadConfirm(format, downloadProgramExcel, downloadProgramPDF);
    } else {
      toast.warn("Please select at least one program 3", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [itineraryPSN, setItineraryPSN] = useState<string | null>(null);
  const [fromDate, setItineraryFromDate] = useState<string | null>(null);
  const [toDate, setItineraryToDate] = useState<string | null>(null);


  const openItineraryModal = (PSN: string, fromDate: string, toDate: string) => {
    setItineraryPSN(PSN);
    setItineraryFromDate(fromDate);
    setItineraryToDate(toDate);
    setShowItineraryModal(true);
  };



  return (
    <div className="row">
      <div className="col-md-6 mb-2">
        <div className="input-group">
          <ListSearchBar criteria={<Dropdown>
            <Dropdown.Toggle variant="link">{translate(localTypeSearch)}</Dropdown.Toggle>
            <Dropdown.Menu>
              {filteredMenuItems.map((item, idx) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleLocalTypeSelection(item)}
                  active={localTypeSearch === item.label}
                >
                  {item.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>

          </Dropdown>} onReset={() =>
              handleAdvancedSearch({
                target: { value: "" },
              } as React.ChangeEvent<HTMLInputElement>)
            } resetLabel={translate("Reset search")}><input
            type="text"
            placeholder={`${translate("Search by")} ${translate(localTypeSearch)}`}
            value={search}
            onChange={handleAdvancedSearch}
            className="form-control"
          /></ListSearchBar>
          <div className="col-md-4 mb-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={filterDate ? dayjs(filterDate) : null}
                onChange={(newValue) => {
                  const val = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
                  onFilterDateChange(val);
                }}
                format="YYYY-MM-DD"
                maxDate={dayjs()}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    placeholder: "Filter by Program Date",
                    sx: {
                      "& .MuiOutlinedInput-root": { height: 40, fontSize: "14px" }
                    },
                  },
                }}
              />
            </LocalizationProvider>


          </div>



        </div>
      </div>

      {/* Limit & Columns */}
      <div className="col-md-8 d-flex justify-content-end align-items-center">

        <button
          className="btn btn-outline-danger mr-1"
          onClick={handleDeleteSelectedPrograms}
        >
          <i className="las la-trash"></i> {translate("Delete")}
        </button>

        <ImportExcelButton
          backendUrl={process.env.REACT_APP_BACKEND_URL || ""}
          userid={localStorage.getItem("userid") || localStorage.getItem("userid") || ""}
          id_site={id_site ?? undefined}
          onSuccess={fetchPrograms}
        />


        <button
          className="btn btn-outline-secondary   mr-1"
          onClick={() => setShowDownloadModalProgram(true)}
        >
          <i className="las la-download"></i>
          {translate("Export")}
        </button>
        <div className="dataTables_length">
          <label style={{ marginLeft: "16px", marginBottom: "0" }}>
            {translate("Show")}
            <select
              className="custom-select custom-select-sm form-control form-control-sm ml-2"
              style={{ width: "66px" }}
              value={limit}
              onChange={handleSelectChange}
            >
              {[10, 20, 50, 100, 200, 500].map((val) => (
                <option key={val} value={val}>
                  {val}
                </option>
              ))}
            </select>
          </label>
        </div>
        <Dropdown>
          <Dropdown.Toggle
            variant="link"
            id="dropdown-basic"
            title="Display Columns"
          >
            <i className="las la-eye"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {Object.entries(columnsMap)
              .filter(([colKey]) => colKey !== "program_date") // Exclure program_date
              .map(([colKey, translation], idx) => (
                <Dropdown.Item
                  key={idx}
                  as="div"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    checked={selectedColumns[colKey as keyof typeof initialColumns]}
                    onChange={() =>
                      handleColumnChange(colKey as keyof typeof initialColumns)
                    }
                  />
                  <span style={{ marginLeft: "10px" }}>{translate(translation)}</span>
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Table */}
      <Table className="dataTable" responsive>
        <thead className="bg-white text-uppercase">
          <tr className="ligth ligth-data">
            <th>
              <div className="form-check" style={{ float: "left" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectAll}
                  onChange={(e) => handleSelectAllPrograms(e.target.checked)}
                />
              </div>
            </th>
            {selectedColumns.id_program && id_user === "1" && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("id_program")}
              >
                {translate("ID")}
              </th>
            )}
            {selectedColumns.program_date && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("program_date")}
              >
                {translate("Program Date")}
              </th>
            )}
            {selectedColumns.site && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("site")}
              >
                {translate("Site")}
              </th>
            )}
            {selectedColumns.client_name && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("client_name")}
              >
                {translate("Client")}
              </th>
            )}
            {selectedColumns.departure && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("departure")}
              >
                {translate("Departure")}
              </th>
            )}
            {selectedColumns.destination && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("destination")}
              >
                {translate("Destination")}
              </th>
            )}
            {selectedColumns.type && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("type")}
              >
                {translate("Type")}
              </th>
            )}
            {selectedColumns.nom_conducteur && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("nom_conducteur")}
              >
                {translate("Driver")}
              </th>
            )}
            {selectedColumns.immatriculation_vehicule && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("immatriculation_vehicule")}
              >
                {translate("Vehicle")}
              </th>
            )}
            {selectedColumns.observation && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("observation")}
              >
                {translate("Observation")}
              </th>
            )}
            {selectedColumns.status && (
              <th
                className="sorting"
                onClick={() => handleSortingColumn("status")}
              >
                {translate("Status")}
              </th>
            )}
            <th>{translate("Action")}</th>
          </tr>
        </thead>
        <tbody className="light-body">
          {loading ? (
            <tr>
              <td colSpan={Object.keys(selectedColumns).length || 10}>
                <div className="d-flex justify-content-center py-3">
                  <PropagateLoader color="#123abc" loading={loading} size={20} />
                </div>
              </td>
            </tr>


          ) : programs.length > 0 ? (
            programs.map((program, index) => (
              <tr key={index}>
                <td>
                  <div className="form-check form-check-inline">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`checkbox-${program.id_program}`}
                      checked={selectedProgramsFromTable.includes(
                        program.id_program?.toString() || ""
                      )}
                      onChange={() =>
                        handleProgramsSelect(
                          program.id_program?.toString() || ""
                        )
                      }
                    />
                    <label
                      htmlFor={`checkbox-${program.id_program}`}
                      className="mb-0"
                    ></label>
                  </div>
                </td>
                {selectedColumns.id_program && id_user === "1" && (
                  <td>{program.id_program}</td>
                )}
                {selectedColumns.program_date && (
                  <td>
                    {program.program_date
                      ? moment(program.program_date).format("DD-MM-YYYY")
                      : ""}
                  </td>
                )}
                {selectedColumns.site && <td>{program.name || ""}</td>}
                {selectedColumns.client_name && (
                  <td>{program.client_name || ""}</td>
                )}
                {selectedColumns.departure && (
                  <td>{program.departure || ""}</td>
                )}
                {selectedColumns.destination && (
                  <td>{program.destination || ""}</td>
                )}
                {selectedColumns.type && <td>{program.type || ""}</td>}
                {selectedColumns.nom_conducteur && (
                  <td>{`${program.nom_conducteur || ""} ${program.prenom_conducteur || ""
                    }`}</td>
                )}
                {selectedColumns.immatriculation_vehicule && (
                  <td
                    id={`vehicle-${program.id_program}`}
                    style={{
                      cursor: copyToClipboard ? "pointer" : "default",
                      position: "relative",
                    }}
                    title={translate("Click to copy")}
                    onClick={() => {
                      if (
                        copyToClipboard &&
                        program.immatriculation_vehicule &&
                        program.id_program
                      )
                        copyToClipboard(
                          program.immatriculation_vehicule,
                          String(program.id_program)
                        );
                    }}
                  >
                    <span
                      style={{
                        color:
                          copiedId === String(program.id_program)
                            ? "#28a745"
                            : "#007bff",
                      }}
                    >
                      {program.immatriculation_vehicule || ""}
                    </span>
                    {copiedId === String(program.id_program) && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-20px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "#28a745",
                          color: "#fff",
                          padding: "2px 5px",
                          borderRadius: "4px",
                          fontSize: "12px",
                        }}
                      >
                        {translate("Copied")}
                      </span>
                    )}
                  </td>
                )}
                {selectedColumns.observation && (
                  <td>{program.observation || ""}</td>
                )}
                {selectedColumns.status && (
                  <td>{getStatusIcon(program.status)}</td>
                )}
                <td className="text-center">
                  <div className="d-flex justify-content-center align-items-center list-action">
                    <Link
                      to={``}
                      className="badge bg-success mr-2"
                      title={translate("Edit")}
                      onClick={() => handleEditProgramModal(program)}
                    >
                      <i
                        className="ri-pencil-line mr-0"
                        style={{ fontSize: "1.2em" }}
                      ></i>
                    </Link>
                    <Link
                      to={``}
                      className="badge bg-primary mr-2"
                      title={translate("Detail")}
                      onClick={() =>
                        handleShowShowProgramModal(program.id_program)
                      }
                    >
                      <i
                        className="las la-eye"
                        style={{ fontSize: "1.2em" }}
                      ></i>
                    </Link>

                    <Link
                      to={``}
                      className="badge bg-info mr-2"
                      title={translate("Show Itinerary")}
                      onClick={() => {
                        console.log("=== Itinerary Calculation ===");
                        console.log("Raw program_date :", program.program_date);

                        const rawFromDate = program.program_date || "";
                        const from = new Date(rawFromDate);

                        console.log("Parsed fromDate (object):", from);

                        const to = new Date(from);
                        to.setDate(to.getDate() + 3);

                        console.log("Calculated toDate (object +2 days):", to);

                        const fromDate = from.toISOString().split("T")[0];
                        const toDate = to.toISOString().split("T")[0];

                        console.log("Final fromDate (YYYY-MM-DD):", fromDate);
                        console.log("Final toDate   (YYYY-MM-DD):", toDate);

                        console.log("PSN:", program.PSN || "");

                        openItineraryModal(
                          program.PSN || "",
                          fromDate + " 00:00:00",
                          toDate + " 23:59:59"
                        );
                      }}


                    >
                      <i className="ri-route-line" style={{ fontSize: "1.2em" }}></i>
                    </Link>



                    <Link
                      to={``}
                      className="badge bg-danger mr-2"
                      title={translate("Delete")}
                      onClick={() =>
                        handleDeleteProgramModal(program.id_program)
                      }
                    >
                      <i
                        className="las la-trash"
                        style={{ fontSize: "1.2em" }}
                      ></i>
                    </Link>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr style={{ textAlign: "center" }}>
              <td colSpan={Object.keys(selectedColumns).length || 10}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Pagination */}
      <div className="row">
        <div className="col-md-6 d-flex align-items-center">
          <span>
            {translate("Displaying")} {programs.length} {translate("on")}{" "}
            {total}
          </span>
        </div>
      </div>

      <ReactPaginate
        previousLabel="previous"
        nextLabel="next"
        breakLabel="..."
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName="pagination justify-content-end"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
        forcePage={currentPage - 1}
      />

      <DownloadModal
        show={showDownloadModalProgram}
        onHide={() => setShowDownloadModalProgram(false)}
        onDownloadConfirm={onDownloadConfirmProgram}
      />

      <ModalDeletePrograms
        show={showDeleteMultipleModal}
        onHide={() => setShowDeleteMultipleModal(false)}
        id_programs={selectedProgramsFromTable.map(Number)}
        onSuccess={() => {
          setSelectedProgramsFromTable([]);
          setSelectAll(false);
          fetchPrograms?.();
        }}
      />

      {showItineraryModal && (
        <ModalItinerary
          show={showItineraryModal}
          onHide={() => setShowItineraryModal(false)}
          psn={itineraryPSN}

          fromDate={fromDate}
          toDate={toDate}
        />

      )}

    </div>
  );
};

export default ProgramTable;
